import { useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

export const useUTMTracking = () => {
  useEffect(() => {
    const trackUTMVisit = async () => {
      try {
        // Get UTM parameters from URL
        const urlParams = new URLSearchParams(window.location.search);
        const utmSource = urlParams.get('utm_source');
        const utmMedium = urlParams.get('utm_medium');
        const utmCampaign = urlParams.get('utm_campaign');
        const utmTerm = urlParams.get('utm_term');
        const utmContent = urlParams.get('utm_content');

        // Only track if at least source, medium, and campaign are present
        if (!utmSource || !utmMedium || !utmCampaign) {
          return;
        }

        console.log('UTM parameters detected:', { utmSource, utmMedium, utmCampaign });

        // Generate or retrieve visitor ID
        let visitorId = localStorage.getItem('utm_visitor_id');
        if (!visitorId) {
          visitorId = `visitor_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
          localStorage.setItem('utm_visitor_id', visitorId);
        }

        // Generate session ID
        let sessionId = sessionStorage.getItem('utm_session_id');
        if (!sessionId) {
          sessionId = `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
          sessionStorage.setItem('utm_session_id', sessionId);
        }

        // Store UTM data in session storage for order attribution
        sessionStorage.setItem('utm_data', JSON.stringify({
          utm_source: utmSource,
          utm_medium: utmMedium,
          utm_campaign: utmCampaign,
          utm_term: utmTerm,
          utm_content: utmContent,
          visitor_id: visitorId,
          session_id: sessionId
        }));

        // Track the visit
        const { error } = await supabase.functions.invoke('track-utm-visit', {
          body: {
            utm_source: utmSource,
            utm_medium: utmMedium,
            utm_campaign: utmCampaign,
            utm_term: utmTerm,
            utm_content: utmContent,
            visitor_id: visitorId,
            session_id: sessionId,
            landing_page: window.location.href,
            referrer: document.referrer || null
          }
        });

        if (error) {
          console.error('Error tracking UTM visit:', error);
        } else {
          console.log('UTM visit tracked successfully');
        }
      } catch (error) {
        console.error('Error in UTM tracking:', error);
      }
    };

    trackUTMVisit();
  }, []);

  // Helper function to get stored UTM data
  const getStoredUTMData = () => {
    const data = sessionStorage.getItem('utm_data');
    return data ? JSON.parse(data) : null;
  };

  return { getStoredUTMData };
};
